//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data: function data() {
        return {
            editArchive: false,
            editDelete: false,
            loading: true,
            guestCardSettings: {},
            archivePeriod: ['30', '45', '90'],
            deletePeriod: ['1', '2']
        };
    },
    mounted: function mounted() {
        var $el = this;
        axios.get('/prototype/person/guest-cards-settings').then(function (response) {
            if (response.data) {
                $el.guestCardSettings = response.data;
                $el.loading = false;
            }
        });
    },


    methods: {
        updateGuestCardSettings: function updateGuestCardSettings() {
            var $el = this;
            this.loading = true;
            var form = document.querySelector('form');
            var formData = new FormData(form);
            formData.append("archive", this.guestCardSettings.archiving_period ? this.guestCardSettings.archiving_period : '');
            formData.append("deletion", this.guestCardSettings.deletion_period ? this.guestCardSettings.deletion_period : '');
            axios.put('/prototype/person/' + this.guestCardSettings.id, formData).then(function (response) {
                if (response.data) {
                    $el.guestCardSettings = response.data;
                    $el.editArchive = false;
                    $el.editDelete = false;
                    $el.loading = false;
                }
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/guest-cards/GuestCardSettings.vue
// module id = cFfT
// module chunks = 0 1